import React from 'react';
import { Formik, Form, Field } from "formik";
import SimpleReactValidator from "simple-react-validator";
import { getUserRole,getLeadCategories,getLeadSubCategories,getLeadStatus } from "../utils/index";
import apiUrl from "../apiUrlConstant";
import axios from "axios";
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select from "react-select";

class LeadStatusUpdate extends React.Component {
    constructor(props) {
        super(props);

        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
        });

        this.state = {
            stages: getLeadStatus(),
            role: getUserRole(),
            statusSelectedLabel: this.props.leadStatus || '',
            initialValues: {
                status: this.props.leadStatus || '',
                comment: ''
            },
            showDropFlags: this.props.leadStatus=='Dropped'?true: false,
            selectedDropReason:'',
            dropLists: [],
        };
    }

    async componentDidMount() {
        try {
            //----------------- fetch Drop reasons ----------------//

            axios.get(`${apiUrl.apiUrl.url}/leads/drop-reason-list`, {
                params: {
                    per_page: 100,
                    page: 1
                },
            })
            .then((response) => {
                if (response.data.status === 'success') {
                    this.setState({
                        dropLists: response.data.data
                    });
                }
            })
            .catch(() => {
                this.setState({ loading: false });
            });

        } catch (error) {
            console.error('Error in update stages:', error);
        }


        
    }

    render() {
        return (
            <div>
                <Formik
                    enableReinitialize={true}
                    initialValues={this.state.initialValues}
                    onSubmit={(values, actions) => {

                        if (this.state.showDropFlags) {
                            if (!values.drop_reason) {
                              this.validator.showMessages();
                              return false;
                            }
                          } else {
                            this.validator.message("Drop Reason", values.drop_reason,"","");
                            if (!this.validator.allValid()) {
                              this.validator.showMessages();
                              return false;
                            }
                          }

                        // if (!this.validator.allValid()) {
                        //     this.validator.getErrorMessages();
                        //     this.validator.showMessages();
                        //     return false;
                        // }

                        values.lead_id = this.props.leadId;

                        axios.post(`${apiUrl.apiUrl.url}/leads/update-lead-status`, values)
                            .then(response => {
                                if (response.data.status === 'success') {
                                    this.props.closeModal();
                                } else {
                                    actions.setSubmitting(false);
                                    actions.setErrors(response.data);
                                }
                            });
                    }}
                >
                    {({
                        values,
                        setFieldValue,
                        handleChange,
                        handleSubmit,
                        isSubmitting
                    }) => (
                        <div className="unitFormContainerNew">
                            <Form 
                            autoComplete="off"
                            onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault(); // Prevent form submission on Enter key press
                                        }
                                    }} onSubmit={handleSubmit}>
                                <div className="newGridSectionParent">
                                    <div className="newGridSectionForFormMain newGridSectionForFormMainOneFr">

                                        <div className="newGridSectionInner">
                                            <label>Status <span className="astrik">*</span></label>
                                            <div className="position-relative">
                                                <Select
                                                    className="basic-single custom-width-class custom-select-style"
                                                    classNamePrefix="custom-select-style-inner"
                                                    name="status"
                                                    value={{
                                                        label: this.state.statusSelectedLabel,
                                                        value: this.state.statusSelectedLabel,
                                                    }}
                                                    onChange={(selectedOption) => {
                                                        setFieldValue('status', selectedOption.label);
                                                        this.setState({
                                                            statusSelectedLabel: selectedOption.label,
                                                            showDropFlags: selectedOption.label=='Dropped'? true:false
                                                        });
                                                    }}
                                                    options={this.state.stages.map((item) => ({
                                                        label: item,
                                                        value: item.item,
                                                    }))}
                                                />
                                                {this.validator.message("Status", values.status, "required", { className: "text-danger" })}
                                            </div>
                                        </div>

                                        { this.state.showDropFlags == true ?

                                            <div className="newGridSectionInner">
                                                <label>Drop Reason <span className="astrik">*</span></label>
                                                <div className="position-relative">
                                                    <Select
                                                        className="basic-single custom-select-style"
                                                        classNamePrefix="custom-select-style-inner"
                                                        name="drop_reason"
                                                        onChange={(selectedOption) => {
                                                            setFieldValue('drop_reason', selectedOption.label);
                                                            this.setState({
                                                                selectedDropReason: selectedOption.label
                                                            });
                                                        }}
                                                        value={{
                                                            label: this.state.selectedDropReason,
                                                            value: this.state.selectedDropReason,
                                                        }}
                                                        options={this.state.dropLists.map((item) => ({
                                                            label: item.title,
                                                            value: item.title,
                                                        }))}
                                                    />
                                                    {this.validator.message("Drop Reason", values.drop_reason, "required", { className: "text-danger" })}
                                                </div>
                                            </div>
                                            : null
                                        }

                                        {/* <div className="newGridSectionInner">
                                            <label>Comment<span className="astrik">*</span></label>
                                            <div className="position-relative">
                                                <Field as="textarea" name="comment" onChange={handleChange} />
                                                
                                                {!this.state.showDropFlags &&
                                                    this.validator.message("Comment", values.comment, "required", { className: "text-danger" })
                                                }
                                            </div>
                                        </div> */}
                                    </div>
                                    <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                                        <button type="button" className='cancel_button' onClick={this.props.closeModal}>
                                            Cancel
                                        </button>
                                        <button type="submit" className='add_button' disabled={isSubmitting}>
                                            {isSubmitting && <FontAwesomeIcon icon={faSpinner} className="spinner-icon" />} Submit
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        </div>
                    )}
                </Formik>
            </div>
        );
    }
}

export default LeadStatusUpdate;
